const config = {
	api: 'https://ecoupon-uat.ust.hk/eta/api',
	appPath: '/eta/app',
	loginTimeout: 18000000,
	googleMapsSearchUrl: 'https://www.google.com/maps/search/?api=1&query=',
	// Lung Wai live shuttle tracker; the type decides which fleet is shown (staff | student).
	gpsTrackerUrl: 'https://ustgps.ibasezero.com/?type=',
	// Analytics is production-only; a blank id keeps AnalyticsHelper inert here.
	gaMeasurementId: ''
};

export default config;
